import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IAdminAuth } from "src/@types/admin-auth";
import { StudioAdminPermission } from "src/@types/studio-admin";

interface AdminLoginResponse {
  accessToken: string;
  adminUser: {
    id: string;
    name: string;
    email: string;
    studioPermissions?: StudioAdminPermission[] | null;
  };
}

export const postAdminLogin: any = createAsyncThunk<
  AdminLoginResponse,
  { email: string; password: string }
>("adminAuth/postAdminLogin", async ({ email, password }, thunkAPI) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/super-admin/login`,
      {
        email,
        password,
      },
    );
    return response.data;
  } catch (error: any) {
    const message =
      error?.response?.data?.message ||
      error?.response?.data?.error ||
      error?.message ||
      "Erro ao fazer login do administrador.";

    return thunkAPI.rejectWithValue(message);
  }
});

const initialState: IAdminAuth = {
  accessToken: "",
  adminUser: {
    id: "",
    name: "",
    email: "",
    studioPermissions: undefined,
  },
  isLoading: false,
  sessionExpired: false,
  error: null,
};

const adminAuthSlice = createSlice({
  name: "adminAuth",
  initialState,
  reducers: {
    adminLogout: (state) => {
      state.accessToken = "";
      state.adminUser = { ...initialState.adminUser };
      state.isLoading = false;
      state.sessionExpired = false;
      state.error = null;
    },
    adminSessionExpired: (state) => {
      state.accessToken = "";
      state.adminUser = { ...initialState.adminUser };
      state.isLoading = false;
      state.sessionExpired = true;
      state.error = null;
    },
    clearAdminSessionExpired: (state) => {
      state.sessionExpired = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(postAdminLogin.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(postAdminLogin.fulfilled, (state, action) => {
        state.isLoading = false;
        state.accessToken = action.payload.accessToken;
        state.adminUser = {
          id: action.payload.adminUser.id,
          name: action.payload.adminUser.name,
          email: action.payload.adminUser.email,
          studioPermissions: action.payload.adminUser.studioPermissions,
        };
        state.sessionExpired = false;
        state.error = null;
      })
      .addCase(postAdminLogin.rejected, (state, action) => {
        state.isLoading = false;
        state.accessToken = "";
        state.adminUser = { ...initialState.adminUser };
        state.error =
          (action.payload as string) ||
          action.error?.message ||
          "Erro ao fazer login do administrador.";
      });
  },
});

export const { adminLogout, adminSessionExpired, clearAdminSessionExpired } =
  adminAuthSlice.actions;

export default adminAuthSlice.reducer;
